import React from "react";
import PropTypes from "prop-types";
import mainStore from "../../../../../stores/main";
var StepResult = function StepResult(_ref) {
  var correctResult = _ref.correctResult;
  var correctResultInfo = /*#__PURE__*/React.createElement("div", {
    className: "step__result-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__result"
  }, /*#__PURE__*/React.createElement("p", {
    className: "step__result__info correct",
    dangerouslySetInnerHTML: {
      __html: mainStore.dictionary.Quiz.correct
    }
  })));
  var wrongResultInfo = /*#__PURE__*/React.createElement("div", {
    className: "step__result-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__result"
  }, /*#__PURE__*/React.createElement("p", {
    className: "step__result__info wrong",
    dangerouslySetInnerHTML: {
      __html: mainStore.dictionary.Quiz.incorrect
    }
  })));
  if (correctResult) {
    return correctResultInfo;
  }
  return wrongResultInfo;
};
export default StepResult;
StepResult.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  correctResult: PropTypes.bool.isRequired
};